<h1 mat-dialog-title class="error-state-dialog-title">
    <mat-icon>warning</mat-icon>
    Form Error
</h1>
<div mat-dialog-content class="error-state-dialog-content">
    <p class="error-state-dialog-text">{{data.errorDetails}}</p>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button (click)="close()" cdkFocusInitial>Ok</button>
</div>
